import { Span } from "@virtual-brain-lib/frontend-design-system/ui";
import { cn } from "@virtual-brain-lib/frontend-design-system/utils";
import type { MessageToolCodeBasedTableAnalysisStep } from "@virtual-brain-lib/types";

export function CodeBasedTableAnalysisStepRow({
	step,
}: {
	readonly step: MessageToolCodeBasedTableAnalysisStep;
}) {
	const hasError = !step.stdout && Boolean(step.error);

	return (
		<div className="flex w-full cursor-default items-center gap-1.5 rounded-sm py-0.5 text-left">
			<Span
				className={cn("flex-1 truncate", step.status === "processing" && "italic")}
				color={hasError ? "danger" : "defaultLight"}
				variant="body-xs"
			>
				{step.label}
			</Span>
		</div>
	);
}
